<template>
    <v-dialog v-model="dialog" scrollable max-width="430px" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <h2 class="text-center">Select Team</h2>

            <v-card-text v-if="teams.length" class="font-weight-bold">
                <v-radio-group v-model="team_id" column>
                    <v-radio v-for="team in teams" :label="team.name" :value="team.id" :key="team.id" color="green"></v-radio>
                </v-radio-group>
            </v-card-text>
            <v-card-text v-else class="text-center font-weight-bold black--text my-10">No Result :(</v-card-text>

            <v-card-actions class="d-flex justify-center">
                <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest" @click="approve">Save</v-btn>
                <v-btn class="transparent green--text ml-4" @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['user_id'],
        data(){
            return {
                team_id: null,
                dialog: false,
                teams: [],
                loadingRequest: false,
            }
        },
        mounted(){
            this.$apiAdmin('teams').get({params: {all: 1}})
                .then((res) => {
                    this.teams = res.data.teams;
                })
        },
        methods: {
            approve: function () {
                if(!this.team_id) {
                    this.$store.dispatch('alert', {type: 2, message: 'Please select team.'});
                    return;
                }
                this.loadingRequest = true;
                this.$apiAdmin('registrations').approve({team_id : this.team_id}, this.user_id)
                    .then(() => {
                        this.$parent.$emit('getUsers');
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully approved.'});
                    }).catch((err) => {
                    if (err.response.status === 422) console.log(err.response.data);
                }).finally(() => {
                    this.loadingRequest = false;
                    this.dialog = false;
                    this.team_id = null;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>